import React, { Component } from 'react';
import {
  isAndroid,
  isIOS,
  isMobile,
} from "react-device-detect";
import { Textfit } from 'react-textfit';

import $ from "jquery";
import { ReactComponent as Logo} from '../img/logo-doneski.svg';
import { ReactComponent as AppleButton} from '../img/download-on-the-app-store-badge-us-uk-rgb-blk-092917.svg';
import { ReactComponent as GoogleButton} from '../img/google-play-badge@1x.svg';

class SharePage extends Component {
    
    constructor(props) {
        super(props);
        this.state = {deeplink: "", jobTitle: ""}
        this.openApp = this.openApp.bind(this);
    }
    
    openApp() {   
        window.location.href = this.state.deeplink;
    }
    openStore() {   
      if (isIOS) {
        window.open('https://apps.apple.com/gb/app/doneski-australia/id1488205624?ign-mpt=uo%3D2')
      } else if (isAndroid) {
        window.open('https://play.google.com/store/apps/details?id=com.doneski_rn')
      } else {
        window.open('https://play.google.com/store/apps/details?id=com.doneski_rn')
      }
  }

    componentDidMount() {
        this.setState({deeplink: ""})

        var url = $(window.location).attr('href');
        var hash = url.split("/");
        var completeUrl = 'https://doneski-pro.herokuapp.com/v1/job-by-hash/' + hash[hash.length-1] 

        $.ajax({
            url: completeUrl,
            type: 'get',
            success: function(data) {
                this.setState({jobTitle: data.data.title})
                //$("#title").text(data.data.title);
                $(".font-item-description").text('View full job in DoneSki App');
                $(".item-content").css('background-image', 'url(' + data.data.assets[0].url + ')');
                //this.setState({deeplink: "doneski://job/" + data.data.id});
                const tempDeeplink = "doneski://job/" + data.data.id
                this.setState({deeplink: tempDeeplink})
            }.bind(this),
            
        });
    
      /**
      * @returns {String}
      */

      }
    render() {
        return (
          <div className="container">
            <div className="content">
              <div className="app-logo">
                <a href="https://www.doneski.com.au/">
                  <Logo />
                </a>
              </div>
              <div className="item-content">
                <div>
                  <div className="item-title">
                    <Textfit mode="multi" className="font-item-title"  id="title">{this.state.jobTitle}</Textfit>
                  </div>
                  <div className="item-description">
                    <div className="font-item-description"></div>
                  </div>
                </div>
                { isMobile &&
                  <div className="button-container">
                    <button className="open-app-button" onClick= {this.openApp}>
                      <div className="font-button-open">Open in app</div>
                    </button>
                    <button className="download-app-button" onClick= {this.openStore}>
                      <div className="font-button">Download app</div>
                    </button>
                  </div>
                }
              </div>
              <div className="footer-container">
                <div className="font-footer">
                Wanted. A good local Tradie. Indroducing the new Instagram of Tradie Apps!
                </div>
              </div>
              <div className="cta-buttons">
                <div>
                  <a href="https://apps.apple.com/gb/app/doneski-australia/id1488205624?ign-mpt=uo%3D2">
                    <AppleButton />
                  </a>
                </div>
                <div>
                  <a href="https://play.google.com/store/apps/details?id=com.doneski_rn">
                    <GoogleButton />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default SharePage